module.exports = __webpack_public_path__ + "static/img/technology-right.8ffddb32.gif";